var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('campaignExpressAdd',{attrs:{"id":_vm.id},on:{"submit":_vm.handleSubmit}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }